import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Form,
  Table,
  Input,
  Button,
  InputGroup,
  CardFooter,
  ListGroup,
  ListGroupItem,
} from "reactstrap";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { get_file } from "connection/api";

// Actions
import { clientList, clientFilter } from "store/actions";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";
import Pagination from "components/Common/Pagination";
import ClientDelete from "pages/Clients/Delete";

const ClientList = (props) => {
  const URL = process.env.REACT_APP_URL;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clientList());
  }, []);

  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(false);
  const [client, setClient] = useState({
    code: "",
    full_name: "",
  });

  const toggle = () => setModal(!modal);

  const onChange = (e) => {
    setSearch(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(clientFilter(`?search=${search}`));
  };

  const resetSearch = () => {
    dispatch(clientFilter(`?search=`));
    setSearch("");
  };

  const onClick = async () => {
    const excel_url = `${URL}report/clientes_excel/`;
    try {
      const response = await get_file(excel_url);
      console.log(response);
      const blob = new Blob([response.data], {
        type: "application/vnd.ms-excel",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Clientes.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error("Error al descargar el archivo", error);
    }
  };

  const params = {
    count: props.clients.count,
    next: props.clients.next,
    previous: props.clients.previous,
    results: props.clients.results,
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Clientes </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Clientes"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={7}>
                      <Link
                        className="btn btn-primary waves-effect waves-light mb-1"
                        to="/clients/create"
                      >
                        Agregar
                      </Link>
                      <Button className="mb-1 ms-2" color="success" type="button" onClick={onClick}>
                        Exportar
                      </Button>
                    </Col>
                    <Col md={5}>
                      <Form className="search-box" onSubmit={onSubmit}>
                        <InputGroup>
                          <Input
                            type="text"
                            className="form-control"
                            name="search"
                            placeholder="Código, nombre, identificación..."
                            value={search}
                            onChange={onChange}
                          />
                          <i className="bx bx-search-alt search-icon" />
                          <Button color="primary" onClick={resetSearch}>
                            <span className=" bx bx-x fa-lg align-middle"></span>
                          </Button>
                        </InputGroup>
                      </Form>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                {params.count > 0 ? (
                  <CardBody className="ps-5 pe-5">
                    {/* <h2 className="mb-3 font-size-20">Lista de clientes</h2> */}
                    <div className="table-responsive">
                      <Table
                        className="table table-borderless table-striped align-middle table-centered table-nowrap mb-3"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <thead className="table-light">
                        <tr>
                          <th>Código</th>
                          <th>Nombre</th>
                          <th>Identificación</th>
                          <th>Teléfono</th>
                          <th>Email</th>
                          <th>Ciudad</th>
                          <th>Acción</th>
                        </tr>
                        </thead>
                        <tbody>
                        {params.results.map((client, idx) => (
                          <tr key={idx}>
                            <th scope="row">{client.code}</th>
                            <td>{client.full_name}</td>
                            <td>{client.document_number}</td>
                            <td>{client.phone_number}</td>
                            <td>{client.email}</td>
                            <td>{client.city}</td>
                            <td>
                              <Link to={`/clients/update/${client.code}`}>
                                <span className="bx bx-edit fa-lg align-middle"></span>
                              </Link>{" "}
                              <button
                                style={{
                                  color: "red",
                                  backgroundColor: "transparent",
                                  border: "none",
                                }}
                                onClick={() => {
                                  setClient({
                                    code: client.code,
                                    full_name: client.full_name
                                  });
                                  toggle();
                                }}
                              >
                                <span className="bx bx-x fa-lg align-middle"></span>
                              </button>
                            </td>
                          </tr>
                        ))}
                        </tbody>
                      </Table>
                    </div>
                    <Pagination
                      count={params.count}
                      next={params.next}
                      previous={params.previous}
                      limit={8}
                      baseUrl="clients/"
                      filterFunction={clientFilter}
                    />
                  </CardBody>
                ) : (
                  <CardBody>
                    <h4 className="card-title">No se encontraron resultados</h4>
                  </CardBody>
                )}
              </Card>
              <ClientDelete
                modal={modal}
                toggleFunction={toggle}
                client={client}
                resetFunction={resetSearch}
              />
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, clients } = state.Client;
  return { error, loading, clients };
};

export default withRouter(connect(mapStateToProps)(ClientList));
